<template>
  <v-card class="mx-auto" tile :loading="laden">
    <v-system-bar color="indigo darken-2" dark>
      <v-spacer></v-spacer>
      <span></span>
    </v-system-bar>

    <v-toolbar color="indigo" dark>
      <v-toolbar-title>Gedicht - Laatste deel</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="sheet = true">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <br />
      <v-container fluid>
        <p style="margin-left: 10px;">
          Je nieuwe auto is ook een gebeurtenis van dit jaar,<br />
          je hebt het maar zwaar.<br />
          Zoveel om op te noemen,<br />
          hou het volgend jaar maar op één ding om op in te zoomen.<br />
          <br />
          Nu is het een test hoe oplettend je was,<br />
          dat komt nu namelijk erg van pas!<br />
          Dat is dan de laatste opdracht,<br />
          je kunt hierna naar de cadeautjes op jacht!
        </p>
      </v-container>
    </v-layout>
    <div class="text-center">
      <v-bottom-sheet v-model="sheet" persistent>
        <v-sheet class="text-center">
          <div class="py-3">
            <b
              >Er was eerder een woord <i>schuingedrukt</i>. Herinner je die
              nog?</b
            ><br />
            <br />
            <p style="font-size:7px !important">Het begon met een "t"!</p>
            <br />
            <br />
            <p class="grey--text">
              Dit was de laatste opdracht. Nadat je hebt geprobeerd te raden,
              mag je de <b>2</b> cadeautjes voorzichtig uit de surprise halen.
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    time: "",
    laden: false,
    sheet: false,
  }),
  methods: {},
  computed: {},
  mounted() {
    let SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;

    recognition.lang = "nl";
    recognition.interimResults = true;

    recognition.addEventListener("result", (event) => {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.time = text.split(" ").pop();
      if (text.includes("jacht")) {
        this.sheet = true;
      }
    });

    recognition.addEventListener("end", () => {
      if (this.$route.name == "Deel4") {
        recognition.start();
      }
    });
    recognition.start();
  },
};
</script>
